const widgetName = 'socialNetworkWidget';
let initialized = false;

function initialize() {

  $(`#${widgetName}`).append('<div class="socialTabContainer"></div>');

  $(`#${widgetName}`).on('click', '.socialNetworkTab', function() {
    var tab = $(this).attr('data-social-network-tab');

    $('.socialNetworkTab').removeClass('activeTab');
    $('.socialFeedContainer').hide();

    $(this).addClass('activeTab');
    $(`#${tab}Container`).show();

  });

  initialized = true;

}


function isCurrent(current, widget) {
  if (current) {
    $(`#${widgetName} #${widget}Tab`).addClass('activeTab');
    $(`#${widgetName} #${widget}Container`).show();
  }
}


// FACEBOOK -----------

function facebookfeed(current) {

  const fbPageURL = $('.socialNetworkIconFacebook').attr('href');
  let fbHeight = "0"
  if ($('body').hasClass('saffireMobileSize')) {
    fbHeight = "450" // Value to be changed depending on design

  } else {
    fbHeight = "450" // Value to be changed depending on design
  }
  
  const fbWidth = 450;

  const facebookfeedTab = `
    <a id="facebookfeedTab" class="socialNetworkTab" data-social-network-tab="facebookfeed">
      <svg viewBox="0 0 800 800"><title>Facebook Tab Icon</title><g id="Facebook_Tab_Icon" data-name="Facebook_Tab_Icon"><path class="circle" d="M400,0C179.09,0,0,179.09,0,400S179.09,800,400,800,800,620.91,800,400,620.91,0,400,0ZM509.06,259.72l-39.54,0c-31,0-37,14.73-37,36.35v47.67h73.93l-9.63,74.66H432.52V610h-77.1V418.42H290.94V343.76h64.47V288.69c0-63.9,39-98.69,96-98.69,27.3,0,50.77,2,57.61,2.94Z"/></g></svg>
    </a>
  `;
  const facebookfeedContainer = `
    <div id="facebookfeedContainer" class="socialFeedContainer" style="display: none;">
      <div class="fb-page" data-href="${fbPageURL}" data-width="${fbWidth}" data-adapt-container-width="true" data-height="${fbHeight}" data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
        <div class="fb-xfbml-parse-ignore">
          <blockquote cite="${fbPageURL}"><a href="${fbPageURL}">Loading...</a></blockquote>
        </div>
      </div>
    </div>
  `;
    
  if (!initialized) {
    initialize();
  }

  $(`#${widgetName} .socialTabContainer`).append(facebookfeedTab);
  $(`#${widgetName}`).append(facebookfeedContainer);

  isCurrent(current, 'facebookfeed');

}


// INSTAGRAM -----------

function instafeed(current) {

  const instafeedTab = `
    <a id="instafeedTab" class="socialNetworkTab" data-social-network-tab="instafeed">
      <svg viewBox="0 0 800 800"><title>Instagram Tab Icon</title><g id="Instagram_Tab_Icon" data-name="Instagram_Tab_Icon"><path class="circle" d="M570.48,283.14c-4.93-13-12.85-23.81-22.58-33.63-17.83-18-39.17-27.3-64.5-27.35q-30.53-.06-61.06,0c-37.71,0-75.41-.11-113.12.1A80.1,80.1,0,0,0,265,235.64c-27.11,17.84-40.94,43.23-41.27,75.65-.29,28.85-.06,57.7-.06,86.55s0,57.41,0,86.12a90.61,90.61,0,0,0,7.55,37c4.95,11.26,12.27,20.75,20.89,29.48,17.62,17.85,38.77,27.28,63.85,27.33q86.12.16,172.25,0a85,85,0,0,0,31.57-5.8c34.49-13.65,56.4-45.46,56.5-82.69.16-58.2.05-116.4,0-174.6A88.16,88.16,0,0,0,570.48,283.14ZM456.12,491.9a99,99,0,0,1-48,15.67c-33.79,2.17-62.55-9-85.85-33.5-16-16.78-25.2-37-27.89-60-2.7-23.2.59-45.43,11.94-66,15.42-28,38.81-45.92,69.91-53.32,54.12-12.87,110.07,19.76,125.79,73.07a113.2,113.2,0,0,1,4.61,32.35C505.69,439.46,489.38,470.42,456.12,491.9ZM508.93,316c-15.47-.16-28.26-13-28.07-28.27a28.21,28.21,0,0,1,56.4,0A28.43,28.43,0,0,1,508.93,316ZM472.6,382.5c-10.43-48.18-65.13-73.14-108.23-49.24-29.42,16.31-44,47.91-37.18,82.82a74.09,74.09,0,0,0,94.42,56.53c30.45-9.19,53.2-37.67,52.73-73.07a61.76,61.76,0,0,0-.5-9.66A74.47,74.47,0,0,0,472.6,382.5ZM400,0C179.09,0,0,179.09,0,400S179.09,800,400,800,800,620.91,800,400,620.91,0,400,0ZM608.45,489.08a120.42,120.42,0,0,1-72.38,111,116,116,0,0,1-47.38,9.87c-57.77,0-115.53.18-173.3-.06-33.75-.14-62.33-12.83-86.09-36.8-10.08-10.17-18.77-21.25-25.13-34.11a120,120,0,0,1-12.27-45.06c-.3-4.14-.35-8.27-.35-12.41q0-41.77,0-83.54c0-28.78-.09-57.55,0-86.33.13-35.26,12.87-65.24,38.5-89.47,17.28-16.33,37.87-26.37,61.33-30.42A125.81,125.81,0,0,1,312.92,190q85.15,0,170.3,0c34.4,0,63.52,12.61,87.71,37.07,11.11,11.23,20.36,23.61,26.85,38a120.13,120.13,0,0,1,10.66,49.78Q608.5,402,608.45,489.08Z"/></g></svg>
    </a>
  `;
  const instafeedContainer = '<div id="instafeedContainer" class="socialFeedContainer" style="display: none;"></div>';
  
  if (!initialized) {
    initialize();
  }

  $(`#${widgetName} .socialTabContainer`).append(instafeedTab);
  $(`#${widgetName}`).append(instafeedContainer);

  const feed = new Instafeed({
    target: 'instafeedContainer'
  });
  feed.run();

  isCurrent(current, 'instafeed');

}

export {facebookfeed, instafeed};